import { useMemo } from 'react';

import { SECURITY } from '../../../shared/featureFlags/flagNames';
import { hasTierFeature } from '../../../shared/subscriptions';
import { window } from '../../globals';

import { isFeatureEnabled } from './featureFlags';

/**
 * Frontend helper function for checking if the user's org has the Security feature enabled.
 * It checks the stored window values and the enabled feature flags which includes features granted by the org's tier.
 */
export const isSecurityEnabled = () =>
  window.security_enabled ||
  !!window.user?.organization?.security_enabled ||
  // We include this because looking at the tier feature Set is faster than our final lookup in enabledFeatureFlags
  hasTierFeature(window.user?.organization?.stripe_plan, SECURITY, window.user?.organization?.stripePriceLimit) ||
  isFeatureEnabled(SECURITY);

/**
 * Frontend helper hook for checking if the user's org has the Security feature enabled and memoizes the result across rerenders.
 * It checks the stored window values and the enabled feature flags which includes features granted by the org's tier.
 * This provides a minor perf improvement, as we don't need to iterate through enabledFeatureFlags[]
 * on every re-render of the component like with `isFeatureEnabled`.
 */
export const useIsSecurityEnabled = () =>
  useMemo(
    () => isSecurityEnabled(),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We want to refresh this if the enabledFeatureFlags change or if one of the other value change.
    [
      window.enabledFeatureFlags,
      window.security_enabled,
      window.user?.organization?.security_enabled,
      window.user?.organization?.stripe_plan,
    ],
  );
